import React from "react";
import daburLogo from "../../../../assets/svg/appIcon.svg";
import { useOutletContext } from "react-router-dom";
import RotatingTextLoader from "./RotatingTextLoader";
import PropTypes from "prop-types";

const DEFAULT_MESSAGES = [
  "Understanding your request",
  "Searching relevant information",
  "Analyzing context",
  "Synthesizing details",
  "Preparing response",
  "Finalizing results"
];

export default function MessageLoader({ messages = DEFAULT_MESSAGES }) {
  const { isMobile } = useOutletContext();

  return (
    <div className="max-w-4xl mt-8 mb-8 space-y-8">
      <div className="flex gap-4 w-[280px] sm:w-full">
        {!isMobile && (
          <div className="w-[40px] flex-shrink-0">
            <img src={daburLogo} alt="Dabur Logo" className="w-[40px]" />
          </div>
        )}
        <div className="text-[#000000] flex flex-col gap-2 overflow-x-auto rounded-bl-lg rounded-br-lg rounded-tr-lg min-h-[44px] justify-center w-fit group">
          <RotatingTextLoader messages={messages} />
        </div>
      </div>
    </div>
  );
}

MessageLoader.propTypes = {
  messages: PropTypes.arrayOf(PropTypes.string),
};
